import React, { ReactElement } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SafeAreaProvider } from 'react-native-safe-area-context';

/**
 * This component is a wrapper for the SafeAreaProvider component.
 * It checks if the SafeAreaProvider is already present in the context and if not, it wraps the children with it.
 * @param param0 children to wrap
 * @returns
 */
export default function KitSafeAreaProvider({
  style,
  children,
}: {
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
}): ReactElement {
  try {
    // Try to use the hook - if it throws, SafeAreaProvider is not present
    useSafeAreaInsets();

    // If we get here, SafeAreaProvider exists

    if (style) {
      return <View style={style}>{children}</View>;
    }

    return <>{children}</>;
  } catch {
    // SafeAreaProvider not found, wrap with it
    return <SafeAreaProvider style={style}>{children}</SafeAreaProvider>;
  }
}
